import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            kits: [],
            newKit: ''
        }
    },
    computed : {

    },
    methods: {
        load: load,
        addNewKit: addNewKit,
        deleteKit: deleteKit,
        updateAdditionalKits: updateAdditionalKits,
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.load()
    }
}

function addNewKit(){
    if(this.newKit === '') return;
    this.kits.push('' + this.newKit);
    this.newKit = '';
}

function deleteKit(item){
    const index = this.kits.indexOf(item);
    if (index > -1) { // only splice array when item is found
        this.kits.splice(index, 1); // 2nd parameter means remove one item only
    }
}

function load() {
    let _self = this;
    AdminApiService.getMembershipsCategories()
        .then((response) => {
           _self.kits = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


function updateAdditionalKits(){
    let _self = this;
    let newModel = {
        categories: this.kits
    }
    AdminApiService.updateMembershipsCategories(newModel)
        .then((response) => {
            window.history.go(-1); return false;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Membership/AddMembershipCategory.js